<template>
  <div>
    <div class="my-con">
      <div>
        <FirstTimersChartArea
          @firsttimers="setFirsttimer"
          @totalfirstimer="setTotalFirstTimer"
        />
      </div>

      <div class="tab-options d-block d-md-none mt-5">
        <div class="s-14 fw-500 col-md-10 px-0 mt-5">
          <div
            class="d-flex flex-column flex-sm-row justify-content-md-between"
          >
            <div>
              <el-tooltip
                class="box-item"
                effect="dark"
                content="Add all members to group"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="c-pointer primary--text"
                  @click="addToGroupDialog = true"
                >
                  <CirclePlus />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Add to group"
                placement="top-start"
              >
                <span class="ml=2" @click="addToGroupSingle = true">
                  <PeopleIcon
                    class="c-pointer primary--text w-18 h-18"
                    style="vertical-align: bottom !important"
                  />
                </span>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Add First Timers to Follow Up"
                placement="top-start"
              >
                <span class="ml=2" @click="addToFollowUpDialog = true">
                  <UserPlus
                    class="c-pointer primary--text w-18 h-18"
                    style="vertical-align: bottom !important"
                  />
                </span>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Archive member(s)"
                placement="top-start"
              >
                <el-icon
                  class="ml-2 c-pointer primary--text"
                  :size="28"
                  @click="displayPositionArchive = true"
                  v-if="checkedFirstTimer.length > 0"
                >
                  <DocumentRemove />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Delete member(s)"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="checkedFirstTimer.length > 0"
                  @click="showConfirmModal1"
                >
                  <Delete />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send SMS"
                placement="top-start"
              >
                <img
                  src="../../assets/ChatCenteredDots.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer"
                  @click="sendMarkedMemberSms"
                  alt="Send SMS"
                />
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send Email"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="checkedFirstTimer.length > 0"
                  @click="sendMarkedMemberEmail"
                >
                  <Message />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send Whatsapp message"
                placement="top-start"
              >
                <img
                  src="../../assets/WhatsappLogo.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer"
                  @click="displayWhatsappDrawer(null)"
                  alt="Send Whatsapp message"
                />
              </el-tooltip>
            </div>
            <!-- <div
              class="d-flex flex-column flex-sm-row justify-content-md-between"
            >
              <el-input
                size="small"
                v-model="searchText"
                placeholder="Search..."
                @input="searchingMember = true"
                @keyup.enter.prevent="searchMemberInDB($event)"
                class="search-input"
              >
                <template #suffix>
                  <el-button
                    style="padding: 5px; height: 22px"
                    @click.prevent="searchText = ''"
                  >
                    <el-icon :size="13">
                      <Close />
                    </el-icon>
                  </el-button>
                </template>
                <template #append>
                  <el-button
                    class="btn-search"
                    @click.prevent="searchMemberInDB($event)"
                  >
                    <el-icon :size="13">
                      <Search />
                    </el-icon>
                  </el-button>
                </template>
              </el-input>
              <div
                style="background: #eeeeee"
                class="ml-2 mt-3 mt-sm-0 d-flex w-100 align-items-center justify-content-center border-radius-8"
              >
                <div
                  @click="toggleFilterFormVissibility"
                  class="mb-0 px-3 d-flex my-3 my-sm-0 c-pointer"
                >
                  <span class="mr-1">
                    {{
                      navigatorLang === "en-US" ? "Filter" : $t("people.filter")
                    }}
                  </span>
                  <el-icon :size="18">
                    <Filter />
                  </el-icon>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="tab-options d-none d-md-block mt-5">
        <div class="table-top col-12 col-md-7 col-lg-7 col-xl-8 px-0 mt-5">
          <div
            class="d-flex flex-column flex-md-row justify-content-md-between"
          >
            <div>
              <el-tooltip
                class="box-item"
                effect="dark"
                content="Add all members to group"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="c-pointer primary--text"
                  @click="addToGroupDialog = true"
                >
                  <CirclePlus />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Add to group"
                placement="top-start"
              >
                <span class="ml=2" @click="addToGroupSingle = true">
                  <PeopleIcon
                    class="c-pointer primary--text w-18 h-18"
                    style="vertical-align: bottom !important"
                  />
                </span>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Add First Timers to Follow Up"
                placement="top-start"
              >
                <span class="ml=2" @click="addToFollowUpDialog = true">
                  <UserPlus
                    class="c-pointer primary--text w-18 h-18"
                    style="vertical-align: bottom !important"
                  />
                </span>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Archive member(s)"
                placement="top-start"
              >
                <el-icon
                  class="ml-2 c-pointer primary--text"
                  :size="28"
                  @click="displayPositionArchive = true"
                  v-if="checkedFirstTimer.length > 0"
                >
                  <DocumentRemove />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item d-flex"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Delete member(s)"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="checkedFirstTimer.length > 0"
                  @click="showConfirmModal1"
                >
                  <Delete />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send SMS"
                placement="top-start"
              >
                <img
                  src="../../assets/ChatCenteredDots.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer primary--text"
                  @click="sendMarkedMemberSms"
                  alt="Send SMS"
                />
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send Email"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="checkedFirstTimer.length > 0"
                  @click="sendMarkedMemberEmail"
                >
                  <Message />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="checkedFirstTimer.length > 0"
                content="Send Whatsapp message"
                placement="top-start"
              >
                <img
                  src="../../assets/WhatsappLogo.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer primary--text"
                  @click="displayWhatsappDrawer(null)"
                  alt="Send Whatsapp message"
                />
              </el-tooltip>
            </div>
            <!-- <div
              class="d-flex flex-column flex-md-row justify-content-md-between"
            >
              <el-input
                size="small"
                v-model="searchText"
                placeholder="Search..."
                @input="searchingMember = true"
                @keyup.enter.prevent="searchMemberInDB($event)"
                class="search-input col-md-12 col-9"
              >
                <template #suffix>
                  <el-button
                    style="padding: 5px; height: 22px"
                    @click.prevent="searchText = ''"
                  >
                    <el-icon :size="13">
                      <Close />
                    </el-icon>
                  </el-button>
                </template>
                <template #append>
                  <el-button
                    class="btn-search"
                    @click.prevent="searchMemberInDB($event)"
                  >
                    <el-icon :size="13">
                      <Search />
                    </el-icon>
                  </el-button>
                </template>
              </el-input>
              <div
                style="background: #eeeeee"
                class="ml-2 mt-3 py-2 mt-md-0 d-flex align-items-center justify-content-center border-radius-8"
              >
                <p
                  @click="toggleFilterFormVissibility"
                  class="mb-0 px-3 d-flex my-3 my-sm-0 c-pointer"
                >
                  <span class="mr-1">
                    {{
                      navigatorLang === "en-US" ? "Filter" : $t("people.filter")
                    }}
                  </span>
                  <el-icon :size="18">
                    <Filter />
                  </el-icon>
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="filter-options" :class="{ 'filter-options-shown': filterFormIsVissible }">
      <div
        class="filter-options"
        :class="{ 'filter-options-shown': filterFormIsVissible }"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-9">
              <div class="row">
                <div
                  class="col-12 col-sm-6 offset-sm-3 offset-md-0 form-group inp w-100"
                >
                  <el-input
                    placeholder="First name"
                    class="w-100"
                    v-model="filter.name"
                  />
                </div>
                <div class="col-12 col-sm-6 form-group d-none d-md-block">
                  <el-input
                    placeholder="Phone number"
                    class="w-100"
                    v-model="filter.phoneNumber"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-3 d-flex flex-column align-items-center">
              <el-button
                :color="primarycolor"
                @click="applyFilter"
                :loading="applyLoading"
                :disabled="disableBtn"
                round
                >Apply</el-button
              >
              <span class="mt-2">
                <el-button @click="clearAll" class="mr-2" text
                  >Clear all</el-button
                >
                <el-button @click="hide" class="mx-2" text>Hide</el-button>
              </span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <Table
        :data="searchMember"
        :headers="firstTimerHeaders"
        :checkMultipleItem="true"
        @checkedrow="handleSelectionChange"
        v-loading="paginatedTableLoading"
        v-if="searchMember.length > 0"
      > -->
      <TableSearch
        :data="searchMember"
        :headers="firstTimerHeaders"
        :dateLoading="dateLoading"
        :nameLoading="nameLoading"
        @showfilter="handleFilter"
        @searchvalue="searchValue"
        @sortbydate="sortByDate"
        @sortbyname="sortByName"
        @update:searchText="handleSearchTextUpdate"
        :checkMultipleItem="true"
        :filterItem="true"
        @checkedrow="handleSelectionChange"
        v-loading="paginatedTableLoading"
      >
        <template #imageURL="{ item }">
          <el-card
            shadow="hover"
            class="c-pointer person-image"
            v-if="item.imageURL"
            style="border-radius: 50%; height: 26px; width: 26px"
          >
            <el-tooltip
              class="box-item"
              effect="dark"
              content="Click to view"
              placement="top-start"
            >
              <el-image
                style="border-radius: 50%; height: 26px; width: 26px"
                :src="item.imageURL"
                fit="cover"
                @click="(selectedImage = item), (imageDialog = true)"
                :lazy="true"
              />
              <!-- <img
                :src="item.imageURL"
                alt=""
                @click="(selectedImage = item), (imageDialog = true)"
                style="
                  border-radius: 50%;
                  height: 26px;
                  width: 26px;
                  object-fit: cover;
                "
              /> -->
            </el-tooltip>
          </el-card>
          <img src="../../assets/table-icon.png" class="mt-1" v-else alt="" />
          <!-- <el-avatar :size="25" v-else
            ><el-icon color="#000000">
              <UserFilled />
            </el-icon>
          </el-avatar> -->
        </template>
        <template v-slot:firstName="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.firstName }} {{ item.lastName }}
          </div>
        </template>
        <template v-slot:phoneNumber="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item && item.phoneNumber ? item.phoneNumber : "" }}
          </div>
        </template>
        <template v-slot:howDidYouAboutUsName="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.howDidYouAboutUsName }}
          </div>
        </template>
        <template v-slot:interestedInJoining="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.interestedInJoining }}
          </div>
        </template>
        <template v-slot:date="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ formatDate(item.date) }}
          </div>
        </template>
        <!-- <template v-slot:date="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">{{ moment
            .parseZone(
              new Date(item.date).toDateString(),
              "YYYY MM DD HH ZZ"
            )
            ._i.substr(4, 11).replaceAll(" ", "_") }}</div>
        </template> -->
        <template v-slot:contactOwner="{ item }">
          <div
            @click="showMemberRow(item)"
            class="c-pointer"
            v-if="item && item.contactOwner"
          >
            {{ item.contactOwner.firstName }} {{ item.contactOwner.lastName }}
          </div>
        </template>
        <template v-slot:lifeCycle="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.lifeCycle }}
          </div>
        </template>
        <template v-slot:interactions="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.interactions }}
          </div>
        </template>
        <template v-slot:action="{ item }">
          <el-dropdown trigger="click">
            <el-icon>
              <MoreFilled />
            </el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <div class="text-color">
                    <router-link
                      :to="
                        item.phoneNumber
                          ? `/tenant/sms/compose?phone=${item.phoneNumber}`
                          : ''
                      "
                      :class="{
                        'fade-text': !item.phoneNumber,
                        'text-color': item.phoneNumber,
                      }"
                    >
                      {{
                        navigatorLang === "en-US"
                          ? "Send SMS"
                          : $t("people.sendSms")
                      }}
                    </router-link>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="text-color">
                    <router-link
                      :to="
                        item.email
                          ? `/tenant/email/compose?phone=${item.email}`
                          : ''
                      "
                      :class="{
                        'fade-text': !item.email,
                        'text-color': item.email,
                      }"
                    >
                      {{
                        navigatorLang === "en-US"
                          ? "Send Email"
                          : $t("people.sendEmail")
                      }}
                    </router-link>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click="displayWhatsappDrawer(item)">
                  <div class="text-color">
                    {{
                      navigatorLang === "en-US"
                        ? "Send Whatsapp"
                        : $t("people.sendWhatsapp")
                    }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="text-color">
                    <router-link
                      :to="`/tenant/contactmanagement/${item.id}?memberType=0`"
                      class="text-color"
                    >
                      {{
                        navigatorLang === "en-US"
                          ? "Follow Up"
                          : $t("people.followUp")
                      }}
                    </router-link>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click="archive(item.id, 'single')">
                  <div class="text-color">Archive</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="text-color">
                    <el-popover
                      placement="top-start"
                      :width="200"
                      trigger="hover"
                    >
                      <template #reference>
                        <span class="el-dropdown-link">
                          {{
                            navigatorLang === "en-US"
                              ? "Convert to member"
                              : $t("people.ConvertMember")
                          }}
                          <el-icon class="el-icon--right"
                            ><arrow-down
                          /></el-icon>
                        </span>
                      </template>
                      <el-icon
                        v-if="membershipCategory.length == 0"
                        class="is-loading"
                        :size="20"
                      >
                        <Loading />
                      </el-icon>
                      <div v-for="i in membershipCategory" :key="i.id">
                        <div
                          class="dropdown-item px-0 c-pointer"
                          @click="chooseCategory(item.id, i.id)"
                        >
                          {{ i.name }}
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.prevent="showConfirmModal(item.id, index)"
                >
                  <div class="text-color">
                    {{
                      navigatorLang === "en-US" ? "Delete" : $t("people.delete")
                    }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </TableSearch>
      <div v-if="searchMember.length == 0" class="push-down">
        <el-alert
          title="First Timer not found"
          type="warning"
          description="Try searching with another keyword"
          show-icon
          center
        />
      </div>
      <div class="d-flex justify-content-end my-3">
        <el-pagination
          v-model:current-page="serverOptions.page"
          v-model:page-size="serverOptions.rowsPerPage"
          background
          layout="total, prev, pager, next, jumper"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <!-- <el-pagination
          v-model:current-page="serverOptions.page"
          v-model:page-size="serverOptions.rowsPerPage"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        /> -->
      </div>
    </div>
    <el-dialog
      v-model="addToGroupDialog"
      title="Add all Firsttimers To Group"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
    >
      <el-select-v2
        v-model="chooseGrouptoMoveAllMembers"
        :options="getAllGroups"
        label="Select a group"
        placeholder="Select a group"
        size="large"
        class="w-100"
      />
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="secondary-button"
            @click="addToGroupDialog = false"
            round
          >
            {{ navigatorLang === "en-US" ? "Cancel" : $t("people.cancel") }}
          </el-button>
          <el-button
            type="primary"
            :color="primarycolor"
            :loading="allGroupLoading"
            @click="getAllMembersAndAddToGroup"
            round
          >
            {{
              navigatorLang === "en-US"
                ? "Add to group"
                : $t("people.add2Group")
            }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="addToGroupSingle"
      title="Add Firsttimer(s) To Group"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
    >
      <el-select-v2
        v-model="chooseGrouptoMoveto"
        :options="getAllGroups"
        label="Select a group"
        placeholder="Select a group"
        size="large"
        class="w-100"
      />
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="secondary-button"
            @click="addToGroupSingle = false"
            round
          >
            {{ navigatorLang === "en-US" ? "Cancel" : $t("people.cancel") }}
          </el-button>
          <el-button
            type="primary"
            :color="primarycolor"
            :loading="singleGroupLoading"
            @click="moveMemberToGroup"
            round
          >
            {{
              navigatorLang === "en-US"
                ? "Add to group"
                : $t("people.add2Group")
            }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="displayPositionArchive"
      title="Archive firsttimer(s)"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
    >
      <p class="p-m-0">
        {{
          navigatorLang === "en-US"
            ? "You are about to archive your firsttimer(s). Do you want to continue ?"
            : $t("people.archiveYourMember")
        }}
      </p>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="secondary-button"
            @click="displayPositionArchive = false"
            round
          >
            {{ navigatorLang === "en-US" ? "No" : $t("people.no") }}
          </el-button>
          <el-button
            :color="primarycolor"
            :loading="archiveLoading"
            @click="archive('', 'multiple')"
            round
          >
            {{ navigatorLang === "en-US" ? "Yes" : $t("people.yes") }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="imageDialog"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : xsOnly ? `90%` : `70%`"
      align-center
    >
      <el-image class="w-100" :src="selectedImage.imageURL" fit="contain" />
      <template #footer>
        <span class="dialog-footer">
          <el-button :color="primarycolor" @click="imageDialog = false" round>
            {{ navigatorLang === "en-US" ? "Done" : $t("people.done") }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>

  <el-drawer
    v-model="showWhatsapp"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
    class="whatsappdrawer"
  >
    <template #header> </template>
    <template #default>
      <div v-if="whatsappClientState">
        <div class="d-flex justify-content-center align-items-center">
          <img src="../../assets/whatsappwhiteoutline.svg" />
          <h4 class="font-weight-700 text-dark mb-0 ml-2">
            {{
              navigatorLang === "en-US"
                ? "Send Whatsapp message to"
                : $t("people.sendWhatsappMessage")
            }}
          </h4>
        </div>
        <h4 class="text-center text-secondary font-weight-600">
          {{
            sendWhatsappToMultiple
              ? "Selected Members"
              : whatsappRecipient.firstName
          }}
        </h4>
      </div>
      <div v-if="whatsappClientState">
        <div>
          <div>
            {{ navigatorLang === "en-US" ? "Recipient" : $t("people.recipient")
            }}{{ sendWhatsappToMultiple ? "s" : "" }}
            <el-tooltip
              class="box-item"
              effect="customized"
              content="<div>Make sure that the numbers are correctly formatted.</div> <div>A correct format should include the country code with the phone number. E.g +2349059403948.</div> <div>It works either with the '+' symbol or without it.</div>"
              raw-content
              placement="top"
            >
              <el-icon>
                <InfoFilled />
              </el-icon>
            </el-tooltip>
          </div>
          <div
            class="d-flex align-items-center flex-wrap"
            v-if="sendWhatsappToMultiple"
          >
            <el-tag
              class="mx-1"
              size="large"
              closable
              v-for="(item, index) in marked
                .filter((i) => i.mobilePhone)
                .splice(0, 10)"
              :key="item.id"
              @close="marked.splice(index, 1)"
              >{{ item.mobilePhone }}</el-tag
            >
            <!-- <div class="multiple_numbers d-flex align-items-center mr-2 mt-2"
                v-for="(item, index) in marked.filter(i => i.mobilePhone).splice(0, 10)" :key="item.id">
                <span>{{ item.mobilePhone }}</span>
                <el-icon class="c-pointer ml-2" @click="marked.splice(index, 1)">
                  <CircleClose />
                </el-icon>
              </div> -->
          </div>
          <vue-tel-input
            class="mt-2"
            style="height: 40px"
            v-model="whatsappRecipient.mobilePhone"
            mode="international"
            v-else
          ></vue-tel-input>
          <div
            v-if="sendWhatsappToMultiple && marked.length > 10"
            class="text-secondary font-weight-600 mt-2"
          >
            and {{ marked.length - 10 }}
            {{ marked.length - 10 > 1 ? "others" : "other" }}
          </div>
        </div>
        <!-- <div class="mt-3">Message</div> -->
        <div class="mt-4">
          <el-input
            type="textarea"
            rows="8"
            placeholder="Enter your message"
            v-model="whatsappmessage"
          ></el-input>
        </div>
      </div>
      <div v-else class="mt-5">
        <AuthenticateWhatsapp />
      </div>
    </template>
    <template #footer v-if="whatsappClientState">
      <el-button :color="primarycolor" @click="sendWhatsapp()" round>
        {{ navigatorLang === "en-US" ? "Send" : $t("people.send") }}
        <img src="../../assets/send-jet.svg" class="ml-2"
      /></el-button>
    </template>
  </el-drawer>

  <el-drawer
    v-model="showSMS"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
  >
    <template #header>
      <h4>
        {{ navigatorLang === "en-US" ? "Send SMS" : $t("people.sendSms") }}
      </h4>
    </template>
    <template #default>
      <div>
        <smsComponent
          :phoneNumbers="contacts"
          @closesidemodal="() => (showSMS = false)"
        />
      </div>
    </template>
  </el-drawer>

  <el-drawer
    v-model="showEmail"
    :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
    direction="rtl"
  >
    <template #header>
      <h4>
        {{ navigatorLang === "en-US" ? "Send Email" : $t("people.sendEmail") }}
      </h4>
    </template>
    <template #default>
      <div>
        <emailComponent
          :selectedGroupMembers="markedFirsttimers"
          @closesidemodal="() => (showEmail = false)"
        />
      </div>
    </template>
  </el-drawer>
  <el-dialog
    v-model="showFilter"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
    class="QRCodeDialog border-radius-20"
    align-center
  >
    <div class="filter-optio">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center text-black h2 fw-500">
            {{ navigatorLang === "en-US" ? "Filter" : $t("people.filter") }}
          </div>
          <div class="col-md-12 text-center text-black s-24">
            {{
              navigatorLang === "en-US"
                ? "Narrow down your search"
                : $t("people.narrowSearch")
            }}
          </div>
          <div class="col-md-12 mt-3">
            <div class="row justify-content-center">
              <div class="col-md-11 form-group">
                <div class="text-black">
                  {{
                    navigatorLang === "en-US"
                      ? "First name"
                      : $t("people.firstName")
                  }}
                </div>
                <el-input
                  placeholder="First name"
                  class="w-100"
                  v-model="filter.name"
                />
              </div>
              <div class="col-md-11 form-group">
                <div class="text-black">
                  {{
                    navigatorLang === "en-US"
                      ? "Phone number"
                      : $t("people.phoneNumber")
                  }}
                </div>
                <el-input
                  placeholder="Phone number"
                  class="w-100"
                  v-model="filter.phoneNumber"
                />
              </div>
              <div class="col-md-11 form-group" v-if="lifeCycle.length > 0">
                <div class="text-black">Lifecycle</div>
                <el-select-v2
                  v-model="selectedLifeCycle"
                  :options="
                    lifeCycle.map((i) => ({ label: i.name, value: i.id }))
                  "
                  label="Choose lifecycle"
                  placeholder="Choose lifecycle"
                  size="large"
                  class="w-100"
                />
              </div>
              <div class="col-md-12 d-flex justify-content-center">
                <el-button
                  class="col-md-11"
                  :color="primarycolor"
                  @click="applyFilter"
                  :loading="applyLoading"
                  size="large"
                  round
                >
                  {{ navigatorLang === "en-US" ? "Apply" : $t("people.apply") }}
                </el-button>
                <!-- :disabled="disableBtn" -->
                <!-- <div class="mt-2 col-md-11">
                      <el-button @click="clearAll" class="mr-2" text
                        >Clear all</el-button
                      > -->
                <!-- <el-button @click="hide" class="mx-2" text>Hide</el-button> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="addToFollowUpDialog"
    :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
    class="border-radius-20"
    align-center
  >
    <div class="row">
      <div class="col-md-12 text-center s-20 font-weight-600 text-dak">
        Add First Timers to Follow Up
      </div>
      <div class="col-md-12 d-lex flex-column align-items-center">
        <div class="text-dak fw-500 col-md-12 mb-2 mt-4 px-0">
          Select Follow-Up Person
        </div>
        <el-select-v2
          v-model="contactOwnerId"
          @change="setContactOwner"
          :options="contactOwners.map((i) => ({ label: i.name, value: i.id }))"
          placeholder="Select Follow-Up Person"
          size="large"
          class="w-100"
        />
      </div>
    </div>
    <div class="col-md-12 d-flex flex-column align-items-center mt-4">
      <el-button
        round
        :color="primarycolor"
        class="text-white w-100"
        @click="saveFollowUp"
      >
        Save
      </el-button>
      <el-button
        class="w-100 secondary-button mt-2"
        text
        round
        @click="addToFollowUpDialog = false"
        >Cancel</el-button
      >
    </div>
  </el-dialog>

  <!-- <SideBar :show="showSMS" :title="'Compose SMS'" @closesidemodal="() => showSMS = false">
    <div class="m-wrapper" :class="{ 'm-wrapper': showSMS, 'no-show': !showSMS }">
      <smsComponent :phoneNumbers="contacts" @closesidemodal="() => showSMS = false" />
    </div>
  </SideBar>
  <SideBar :show="showEmail" :title="'Compose Email'" @closesidemodal="() => showEmail = false">
    <div class="m-wrapper2">
      <emailComponent :selectedGroupMembers="markedFirsttimers" @closesidemodal="() => showEmail = false" />
    </div>
  </SideBar> -->
</template>

<script>
import { ref, computed, watch, watchEffect, inject } from "vue";
import SideBar from "../groups/sidemodal/SideModal.vue";
import smsComponent from "../groups/component/smsComponent.vue";
import emailComponent from "../groups/component/emailComponent.vue";
import FirstTimersChartArea from "./FirstTimersChartArea.vue";
import axios from "@/gateway/backendapi";
import dateFormatter from "../../services/dates/dateformatter";
import membershipservice from "../../services/membership/membershipservice";
import groupsService from "../../services/groups/groupsservice";
import moment from "moment";
import api from "axios";
import stopProgressBar from "../../services/progressbar/progress";
import { useStore } from "vuex";
import { ElMessageBox, ElNotification } from "element-plus";
import router from "../../router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import PeopleIcon from "../../components/icons/PeopleIcon.vue";
import UserPlus from "../../components/icons/UserPlus.vue";
import Table from "@/components/table/Table";
import TableSearch from "../../components/table/TableSorting.vue";
import frmservice from "@/services/FRM/firsttimermanagement";
import { whatsappServerBaseURL } from "../../gateway/backendapi";
import AuthenticateWhatsapp from "../../components/whatsapp/AuthenticateWhatsapp.vue";

export default {
  props: ["firstTimersList", "totalItems", "currentUserData"],
  components: {
    UserPlus,
    PeopleIcon,
    TableSearch,
    FirstTimersChartArea,
    smsComponent,
    emailComponent,
    SideBar,
    AuthenticateWhatsapp,
    Table,
  },

  setup(props, { emit }) {
    const store = useStore();
    const primarycolor = inject("primarycolor");
    const churchMembers = ref([]);
    const navigatorLang = ref(navigator.language);
    const currentUser = ref({});
    const showWhatsapp = ref(false);
    const filter = ref({});
    const searchIsVisible = ref(false);
    const addToGroupSingle = ref(false);
    const archiveLoading = ref(false);
    const addToGroupDialog = ref(false);
    const singleGroupLoading = ref(false);
    const allcountries = ref([]);
    const allGroupLoading = ref(false);
    const nameLoading = ref(false);
    const dateLoading = ref(false);
    const filterResult = ref([]);
    const chooseGrouptoMoveto = ref();
    const markedFirsttimers = ref([]);
    const marked = ref([]);
    const searchText = ref("");
    const membershipCategory = ref([]);
    const getAllGroups = ref([]);
    const contacts = ref([]);
    const tenantID = ref("");
    const selectedLink = ref(null);
    const totalFirstTimer = ref("");
    const totalItems = ref(props.totalItems);
    const chooseGrouptoMoveAllMembers = ref();
    const showSMS = ref(false);
    const showEmail = ref(false);
    const paginatedTableLoading = ref(false);
    const displayPositionArchive = ref(false);
    const selectedImage = ref({});
    const imageDialog = ref(false);
    const { xsOnly, mdAndUp, lgAndUp, xlAndUp } = deviceBreakpoint();
    const applyLoading = ref(false);
    const searchingMember = ref(true);
    const showFilter = ref(false);
    const filterFormIsVissible = ref(false);
    const lifeCycle = ref([]);
    const selectedLifeCycle = ref(null);
    const whatsappRecipient = ref("");
    const whatsappmessage = ref("");
    const sortDate = ref("");
    const sortName = ref("");
    const tenantCountry = ref({});
    const selectedContactOwner = ref({});
    const contactOwners = ref([]);
    const contactOwnerId = ref(null);
    const sendWhatsappToMultiple = ref(false);
    const addToFollowUpDialog = ref(false);
    const toggleFilterFormVissibility = () => {
      showFilter.value = true;
      // (filterFormIsVissible.value = !filterFormIsVissible.value);
    };

    const toggleSearch = () => {
      searchIsVisible.value = !searchIsVisible.value;
    };
    const setContactOwner = (item) => {
      selectedContactOwner.value = contactOwners.value.find((i) => {
        return i.id == contactOwnerId.value;
      });
    };
    const getContactOwners = () => {
      axios
        .get(`/api/FirsttimerManager/contactowners`)
        .then((res) => {
          contactOwners.value = res.data.map((i) => {
            i.name = i.firstName + " " + i.lastName;
            return i;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getContactOwners();

    const saveFollowUp = async () => {
      if (!contactOwnerId.value) {
        ElNotification({
          type: "warning",
          message: "Please select a follow-up person",
        });
        return;
      }

      if (checkedFirstTimer.value.length === 0) {
        ElNotification({
          type: "warning",
          message: "No first timer selected",
        });
        return;
      }

      const payload = {
        ownerID: contactOwnerId.value,
        firstTimerID: checkedFirstTimer.value.map((i) => i.id), // extract IDs
      };

      console.log("Payload to backend:", payload);

      try {
        await axios.post(
          "/api/People/assignMutipleContactToContactOwner",
          payload
        );

        ElNotification({
          type: "success",
          message: "Added to follow-up successfully",
        });

        addToFollowUpDialog.value = false;
        contactOwnerId.value = null;
      } catch (err) {
        ElNotification({
          type: "error",
          message: "Error processing request",
        });
      }
    };

    const sortByDate = async (item) => {
      if (item) {
        dateLoading.value = true;
        try {
          const { data } = await axios.get(
            `/api/People/GetAllFirstTimers?page=1&sort=date`
          );
          churchMembers.value = data.response.data;
          dateLoading.value = false;
        } catch (error) {
          console.log(error);
          dateLoading.value = false;
        }
      } else {
        dateLoading.value = true;
        try {
          const { data } = await axios.get(
            `/api/People/GetAllFirstTimers?page=1&sort=-date`
          );
          churchMembers.value = data.response.data;
          dateLoading.value = false;
        } catch (error) {
          console.log(error);
          dateLoading.value = false;
        }
      }
    };
    const sortByName = async (item) => {
      if (item) {
        nameLoading.value = true;
        try {
          const { data } = await axios.get(
            `/api/People/GetAllFirstTimers?page=1&sort=name`
          );
          churchMembers.value = data.response.data;
          nameLoading.value = false;
        } catch (error) {
          console.log(error);
          nameLoading.value = false;
        }
      } else {
        nameLoading.value = true;
        try {
          const { data } = await axios.get(
            `/api/People/GetAllFirstTimers?page=1&sort=-name`
          );
          churchMembers.value = data.response.data;
          nameLoading.value = false;
        } catch (error) {
          console.log(error);
          nameLoading.value = false;
        }
      }
    };

    const firstTimerHeaders = ref([
      { name: "PICTURE", value: "imageURL" },
      { name: "NAME", value: "firstName" },
      { name: "PHONE", value: "phoneNumber" },
      { name: "SOURCE", value: "howDidYouAboutUsName" },
      { name: "INTERESTED", value: "interestedInJoining" },
      { name: "DATE", value: "date" },
      { name: "LIFE CYCLE", value: "lifeCycle" },
      { name: "FOLLOWUP PERSON", value: "contactOwner" },
      { name: "INTERACTION", value: "interactions" },
      { name: "ACTION", value: "action" },
    ]);

    const serverOptions = ref({
      page: 1,
      rowsPerPage: 50,
    });

    watch(
      serverOptions.value,
      () => {
        getPeopleByPage();
      },
      { deep: true }
    );

    const getPeopleByPage = async () => {
      paginatedTableLoading.value = true;
      try {
        const { data } = await axios.get(
          `/api/People/GetAllFirstTimers?page=${serverOptions.value.page}`
        );
        if (data && data.response.data.length > 0) {
          churchMembers.value = data.response.data;
        } else {
          ElNotification({
            type: "warning",
            message: "Page not Found, Pls Go back to the Previous one",
            duration: 5000,
          });
        }
        paginatedTableLoading.value = false;
      } catch (error) {
        paginatedTableLoading.value = false;
        console.log(error);
      }
    };
    const handleSelectionChange = (val) => {
      checkedFirstTimer.value = val;

      marked.value = val.map((i) => {
        i.phoneNumber =
          i.phoneNumber && i.phoneNumber.substring(0, 1) == "0"
            ? `+${tenantCountry.value.phoneCode}${i.phoneNumber.substring(1)}`
            : `${i.phoneNumber}`;
        return i;
      });
      console.log(marked.value, "gjjgjhgk");
    };
    const handleFilter = (newValue) => {
      showFilter.value = newValue;
    };
    const handleSearchTextUpdate = (newValue) => {
      searchText.value = newValue;
    };
    const searchValue = (item) => {
      if (item == true) {
        searchText.value;
        searchMemberInDB();
      } else {
        return false;
      }
    };

    const handleSizeChange = (val) => {
      console.log(`${val} items per page`);
    };
    const handleCurrentChange = (val) => {
      console.log(`current page: ${val}`);
    };
    const chooseGroupforAllmembers = (item) => {
      chooseGrouptoMoveAllMembers.value = item;
    };

    const showMemberRow = (item) => {
      router.push(`/tenant/contactmanagement/${item.id}?memberType=0`);
    };
    const clientSessionId = computed(() => {
      if (!store.getters["communication/whatsappSessionId"]) return "";
      return store.getters["communication/whatsappSessionId"];
    });

    const sendTextMessage = async (payload) => {
      try {
        let { data } = await api.post(
          `${whatsappServerBaseURL}send/text?key=${clientSessionId.value}`,
          payload
        );
        console.log(data);

        if (!data.error) {
        }
      } catch (error) {
        console.error(error);
      }
    };

    // const sendWhatsapp = () => {
    //   const recipient =
    //     markedFirsttimers.value && markedFirsttimers.value.length
    //       ? markedFirsttimers.value.map((i) => ({
    //           name: `${i?.firstName} ${i?.lastName}`,
    //           phoneNumber: i.mobilePhone,
    //         }))
    //       : [
    //           {
    //             name: `${whatsappRecipient.value?.firstName} ${whatsappRecipient.value?.lastName}`,
    //             phoneNumber: whatsappRecipient.value.mobilePhone,
    //           },
    //         ];

    //   const textPayload = {
    //     id: recipient,
    //     message: whatsappmessage.value,
    //   };
    //   sendTextMessage(textPayload);
    //   showWhatsapp.value = false;
    //   swal(" Success", "Whatsapp message sent successfully!", "success");
    // };
    const sendWhatsapp = () => {
      const recipient =
        marked.value && marked.value.length
          ? marked.value.map((i) => ({
              name: `${i?.firstName} ${i?.lastName}`,
              phoneNumber: i.phoneNumber,
            }))
          : [
              {
                name: `${whatsappRecipient.value?.firstName} ${whatsappRecipient.value?.lastName}`,
                phoneNumber: whatsappRecipient.value.phoneNumber,
              },
            ];

      const textPayload = {
        id: recipient,
        message: whatsappmessage.value,
      };
      sendTextMessage(textPayload);
      showWhatsapp.value = false;
      swal(" Success", "Whatsapp message sent successfully!", "success");
    };
    const displayWhatsappDrawer = (item) => {
      showWhatsapp.value = true;
      if (item) {
        whatsappRecipient.value = item;
        sendWhatsappToMultiple.value = false;
      } else {
        // marked.value = marked.value.filter(i => i.mobilePhone).splice(0, 10)
        sendWhatsappToMultiple.value = true;
      }
    };

    const totalFirsttimersCount = computed(() => {
      if (
        !totalFirstTimer.value
        //  !totalItems.value
      )
        return 0;
      return totalFirstTimer.value;
      // return totalItems.value;
    });
    const whatsappClientState = computed(() => {
      return store.getters["communication/isWhatsappClientReady"];
    });

    const deleteMember = (id) => {
      axios
        .delete(`/api/People/DeleteOnePerson/${id}`)
        .then(() => {
          ElNotification({
            type: "success",
            showClose: true,
            message: "Member deleted successfully",
            duration: 5000,
          });
          churchMembers.value = churchMembers.value.filter(
            (item) => item.id !== id
          );
          store.dispatch("membership/removeFirstTimerFromStore", id);
          store.dispatch("dashboard/getDashboard");
        })
        .catch((err) => {
          /eslint no-undef: "warn"/;
          NProgress.done();
          if (err.response.status === 400) {
            ElNotification({
              type: "success",
              showClose: true,
              message:
                "Unable to delete, Ensure this member is not in any group",
              duration: 5000,
            });
          } else {
            ElNotification({
              type: "success",
              showClose: true,
              message: "Unable to delete, an error occured,please try again",
              duration: 5000,
            });
          }
        });
    };

    const showConfirmModal = (id, index) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteMember(id, index);
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
          });
        });
    };

    watchEffect(() => {
      if (props.firstTimersList) {
        churchMembers.value = props.firstTimersList;
      }
    });

    const applyFilter = () => {
      console.log(selectedLifeCycle.value);
      const lifecycle = lifeCycle.value.find(
        (i) => i.id === selectedLifeCycle.value
      );
      // console.log(lifecycle)
      applyLoading.value = true;
      filter.value.name =
        filter.value.name == undefined ? "" : filter.value.name;
      filter.value.phoneNumber =
        filter.value.phoneNumber == undefined ? "" : filter.value.phoneNumber;
      filter.value.lifecycle = lifecycle?.name ?? "";

      let url =
        "/api/People/FilterFirstTimers?firstname=" +
        filter.value.name +
        // "&lastname=" +
        // filter.value.name +
        "&phone_number=" +
        filter.value.phoneNumber +
        "&lifecycle=" +
        filter.value.lifecycle +
        "&page=1";
      axios
        .get(url)
        .then((res) => {
          // noRecords.value = true;
          filterResult.value = res.data;
          applyLoading.value = false;
          showFilter.value = false;
        })
        .catch(
          (err) => console.log(err),
          (applyLoading.value = false),
          (showFilter.value = false)
        );
    };

    const searchNamesInDB = ref([]);
    const searchMemberInDB = () => {
      searchingMember.value = true;
      paginatedTableLoading.value = true;
      let url = `/api/People/FilterFirstTimers?firstname=${searchText.value}&&lastname=${searchText.value}&&phone_number=${searchText.value}&&LifeCycle=${searchText.value}`;
      axios
        .get(url)
        .then((res) => {
          searchingMember.value = false;
          searchNamesInDB.value = res.data;
          paginatedTableLoading.value = false;
          if (res.data.length === 0) {
            ElNotification({
              type: "warning",
              message: `${searchText.value} not found, please try add a new firsttimer and search again`,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          searchingMember.value = false;
          paginatedTableLoading.value = false;
        });
    };

    const listOfFirsttimers = computed(() => {
      if (searchText.value !== "") return searchNamesInDB.value;
      return churchMembers.value;
    });
    // Tosin

    const searchMember = computed(() => {
      if (searchText.value !== "" && searchNamesInDB.value.length > 0) {
        return searchNamesInDB.value;
      } else if (
        searchNamesInDB.value.length == 0 &&
        searchText.value !== "" &&
        !paginatedTableLoading.value &&
        !searchingMember.value
      ) {
        return [];
      } else if (
        filter.value.name ||
        filter.value.phoneNumber ||
        filter.value.lifecycle
      ) {
        return filterResult.value;
      } else {
        return churchMembers.value;
      }
    });

    const hide = () => {
      filterFormIsVissible.value = false;
    };

    // const disableBtn = computed(() => {
    //   if (!filter.value.name && !filter.value.phoneNumber) return true;
    //   return false;
    // });

    const membersCount = computed(() => {
      if (totalFirstTimer.value > 100)
        return Math.ceil(totalFirstTimer.value / 100);
      return 1;
    });

    const formatDate = (date) => {
      return dateFormatter.monthDayYear(date);
    };

    const clearInput = () => {
      searchText.value = "";
    };

    const clearAll = () => {
      filter.value.name = "";
      filter.value.phoneNumber = "";
    };

    // function to checkmark a single first timer
    const checkedFirstTimer = ref([]);

    const check1item = (ft) => {
      const firstTimerIdx = checkedFirstTimer.value.findIndex(
        (i) => i.id === ft.id
      );
      if (firstTimerIdx < 0) {
        checkedFirstTimer.value.push(ft);
      } else {
        checkedFirstTimer.value.splice(firstTimerIdx, 1);
      }
    };

    // function to check all first timer
    const markAllFirsttimer = () => {
      if (checkedFirstTimer.value.length < churchMembers.value.length) {
        churchMembers.value.forEach((i) => {
          const ftInMarked = checkedFirstTimer.value.findIndex(
            (f) => f.id === i.id
          );
          if (ftInMarked < 0) {
            checkedFirstTimer.value.push(i);
          }
        });
      } else {
        checkedFirstTimer.value = [];
      }
    };

    // Function to delete first timer
    const convert = (x) => {
      return x.map((i) => i.id);
    };
    const deleteMessage = ref("");
    const display = ref(false);

    const deleteFirstTimer = () => {
      let dft = convert(checkedFirstTimer.value);
      axios
        .post(`/api/People/DeletePeople`, dft)
        .then((res) => {
          let incomingRes = res.data.response;
          if (incomingRes.toString().toLowerCase().includes("all")) {
            ElNotification({
              type: "success",
              showClose: true,
              message: "First Timer(s) deleted successfully.",
              duration: 5000,
            });
            churchMembers.value = churchMembers.value.filter((item) => {
              const y = checkedFirstTimer.value.findIndex(
                (i) => i.id === item.id
              );
              if (y >= 0) return false;
              return true;
            });
          } else {
            let resArr = incomingRes.split("@");
            ElNotification({
              type: "info",
              showClose: true,
              message: resArr[0],
              duration: 5000,
            });

            if (resArr[1] !== "") {
              if (!resArr[1].includes(",")) {
                churchMembers.value = churchMembers.value.filter((item) => {
                  return !item.id.includes(resArr[1]);
                });
              } else {
                let IdArr = resArr[1].split(",");
                churchMembers.value = churchMembers.value.filter((item) => {
                  const y = IdArr.findIndex((i) => i === item.id);
                  if (y >= 0) return false;
                  return true;
                });
              }
            }
          }
          checkedFirstTimer.value = [];
        })
        .catch((err) => {
          stopProgressBar();
          if (err.toString().toLowerCase().includes("network error")) {
            ElNotification({
              type: "warning",
              showClose: true,
              message:
                "Network error, please ensure you have a strong internet connection",
              duration: 5000,
            });
          } else if (err.toString().toLowerCase().includes("timeout")) {
            ElNotification({
              type: "warning",
              showClose: true,
              message: "Request took too long to respond, please try again",
              duration: 5000,
            });
          } else {
            ElNotification({
              type: "warning",
              showClose: true,
              message: "Unable to delete first timer",
              duration: 5000,
            });
          }
        });
    };

    const sendMarkedMemberSms = () => {
      contacts.value = checkedFirstTimer.value
        .filter((i) => i.phoneNumber)
        .map((i) => i.phoneNumber)
        .join();
      showSMS.value = true;
    };

    const sendMarkedMemberEmail = () => {
      showEmail.value = true;
      markedFirsttimers.value = checkedFirstTimer.value.map((i) => {
        i.id = i.id;
        return i;
      });
    };

    const modal = () => {
      ElMessageBox.confirm("Are you sure you want to proceed?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          deleteFirstTimer();
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
          });
        });
    };

    const getMembershipCategory = async () => {
      try {
        let { data } = await axios.get(
          "/api/Settings/GetTenantPeopleClassification"
        );
        membershipCategory.value = data;
      } catch (err) {
        console.log(err);
      }
    };
    getMembershipCategory();

    const chooseCategory = async (personId, categoryId) => {
      try {
        let { data } = await axios.post(
          `/api/People/ConvertFirstTimerToMember?personId=${personId}&membershipCategoryId=${categoryId}`
        );
        churchMembers.value = churchMembers.value.filter((i) => {
          return i.id !== personId;
        });
        if (data.response) {
          ElNotification({
            type: "success",
            showClose: true,
            message: data.response,
            duration: 5000,
          });
        } else {
          ElNotification({
            type: "success",
            showClose: true,
            message: "Moved succesfully",
            duration: 5000,
          });
        }
      } catch (err) {
        console.log(err);
        if (err.response) {
          ElNotification({
            type: "warning",
            showClose: true,
            message: "Moved failed, " + err.response,
            duration: 5000,
          });
        } else if (err.toString().toLowerCase().includes("timeout")) {
          ElNotification({
            type: "warning",
            showClose: true,
            message: "Request took too long to respond, please try again",
            duration: 5000,
          });
        } else if (err.toString().toLowerCase().includes("network error")) {
          ElNotification({
            type: "warning",
            showClose: true,
            message: "Please ensure that you have a strong internet",
            duration: 5000,
          });
        } else {
          ElNotification({
            type: "warning",
            showClose: true,
            message:
              "Couldn't move successfully, check your connection and try again",
            duration: 5000,
          });
        }
      }
    };

    const setFirsttimer = (payload) => {
      churchMembers.value = payload;
    };

    const getUser = computed(() => {
      if (
        !store.getters.currentUser ||
        (store.getters.currentUser &&
          Object.keys(store.getters.currentUser).length == 0)
      )
        return "";
      return store.getters.currentUser;
    });
    watchEffect(() => {
      if (getUser.value) {
        currentUser.value = getUser.value;
      } else {
        currentUser.value = props.currentUserData;
      }

      if (
        allcountries.value.length > 0 &&
        getUser.value &&
        Object.keys(getUser.value).length > 0
      ) {
        tenantCountry.value = allcountries.value.find((i) => {
          return i.isoCode == getUser.value.isoCode;
        });
      } else {
        tenantCountry.value = allcountries?.value.find((i) => {
          return i.isoCode == props.currentUserData.isoCode;
        });
      }
    });
    const getAllCountries = async () => {
      try {
        let { data } = await axios.get("/api/getallcountries");
        allcountries.value = data;
      } catch (error) {
        console.error(error);
      }
    };

    getAllCountries();

    const deleteMarked = async () => {
      try {
        // const IDs = marked.value.map((i) => i.id).join();
        const IDs = checkedFirstTimer.value.map((i) => i.id);
        console.log(IDs, "IDS");
        const response = await membershipservice.deletePeople(IDs);

        if (
          response &&
          response.response &&
          response.response.toString().toLowerCase().includes("all")
        ) {
          ElNotification({
            type: "success",
            message: "Delete successful",
            duration: 7000,
          });

          churchMembers.value = churchMembers.value.filter((item) => {
            const y = checkedFirstTimer.value.findIndex(
              (i) => i.id === item.id
            );
            if (y >= 0) return false;
            return true;
          });
        } else {
          let displayRes =
            response && response.response ? response.response.split("@") : "";
          ElNotification({
            type: "info",
            message: `${displayRes[0]}`,
            duration: 7000,
          });

          if (displayRes && displayRes[1] && displayRes[1] !== "") {
            if (!displayRes[1].includes(",")) {
              churchMembers.value = churchMembers.value.filter((item) => {
                return !item.id.includes(displayRes[1]);
              });
            } else {
              let IDs = displayRes[1].split(",");
              churchMembers.value = churchMembers.value.filter((item) => {
                const y = IDs.findIndex((i) => i === item.id);
                if (y >= 0) return false;
                return true;
              });
            }
          }
        }
        checkedFirstTimer.value = [];
        store.dispatch("membership/setFirstTimerData");
        store.dispatch("dashboard/getDashboard");
      } catch (error) {
        console.log(error);
        ElNotification({
          type: "warning",
          message: "Delete failed, please try again",
          duration: 4000,
        });
        // }
      }
    };

    const showConfirmModal1 = () => {
      ElMessageBox.confirm(
        "This action will permanently delete the firsttimer(s). Continue?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteMarked();
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
          });
        });
    };

    const chooseGroupto = (items) => {
      chooseGrouptoMoveto.value = items;
    };

    const getGroups = async () => {
      try {
        const data = await groupsService.getGroups();
        getAllGroups.value = data.response.groupResonseDTO.map((i) => {
          return {
            label: i.name,
            value: i.id,
          };
        });
      } catch (error) {
        console.error(error);
      }
    };
    getGroups();

    const moveMemberToGroup = () => {
      singleGroupLoading.value = true;
      let peopleMoved = checkedFirstTimer.value.map((i) => {
        return {
          groupId: chooseGrouptoMoveto.value,
          position: "FirstTimer",
          personId: i.id,
        };
      });
      axios
        .put(`/api/AssignPeopleToGroup/${chooseGrouptoMoveto.value}`, {
          people: peopleMoved,
        })
        .then(() => {
          singleGroupLoading.value = false;
          addToGroupSingle.value = false;

          ElNotification({
            message: "Firsttimer added successfully",
            type: "success",
          });

          store.dispatch("groups/updateGroupPeopleCount", {
            groupId: chooseGrouptoMoveto.value,
            count: checkedFirstTimer.value.length,
            operation: "add",
          });

          checkedFirstTimer.value = [];
        })
        .catch((err) => {
          stopProgressBar();
          ElNotification({
            message: "Adding Member(s) failed, please try again",
            type: "error",
          });
          singleGroupLoading.value = false;
          addToGroupSingle.value = false;
        });
    };
    const openPositionArchive = () => {
      displayPositionArchive.value = true;
    };

    const getAllMembersAndAddToGroup = () => {
      allGroupLoading.value = true;
      axios
        .post(
          `/api/Group/AddAllMembersToGroup?groupId=${chooseGrouptoMoveAllMembers.value}&tenantId=${tenantID.value}`
        )
        .then(() => {
          ElNotification({
            message: "All Firsttimer have been added successfully",
            type: "success",
          });
          addToGroupDialog.value = false;
          allGroupLoading.value = false;
        })
        .catch((err) => {
          allGroupLoading.value = false;
          addToGroupDialog.value = false;
          console.log(err);
        });
    };

    const archive = async (id, type) => {
      archiveLoading.value = true;
      let archiveBody =
        type == "single" ? [id] : checkedFirstTimer.value.map((i) => i.id);
      try {
        const { data } = await axios.post("/api/People/archive", archiveBody);
        archiveLoading.value = false;
        displayPositionArchive.value = false;
        if (data && type == "single") {
          churchMembers.value = churchMembers.value.filter((item) => {
            return item.id !== id;
          });
          ElNotification({
            message: "FirstTimer archived succesfully",
            type: "success",
          });
        }
        if (data && type == "multiple") {
          churchMembers.value = churchMembers.value.filter((item) => {
            let y = checkedFirstTimer.value.findIndex((j) => j.id == item.id);
            if (y >= 0) return false;
            return true;
          });
          ElNotification({
            message: "FirstTimer archived succesfully",
            type: "success",
          });
        }
      } catch (err) {
        archiveLoading.value = false;
        displayPositionArchive.value = false;
        console.log(err);
      }
    };

    watchEffect(() => {
      if (getUser.value) {
        tenantID.value = getUser.value.tenantId;
      }
    });

    const firstTimerLink = computed(() => {
      if (!tenantID.value) return "";
      return `${window.location.origin}/createfirsttimer/${tenantID.value}`;
    });

    const copylink = () => {
      selectedLink.value.input.setSelectionRange(
        0,
        selectedLink.value.input.value.length
      ); /* For mobile devices */
      selectedLink.value.input.select();

      /* Copy the text inside the text field */
      document.execCommand("copy");
      ElNotification({
        showClose: true,
        message: "Copied to clipboard",
        type: "success",
      });
    };

    const setTotalFirstTimer = (payload) => {
      totalFirstTimer.value = payload;
    };

    const getLifeCycle = async () => {
      try {
        let res = await frmservice.getLifeCycle();
        lifeCycle.value = res.returnObject.sort((a, b) => a.order - b.order);
      } catch (err) {
        console.log(err);
      }
    };
    getLifeCycle();

    return {
      saveFollowUp,
      addToFollowUpDialog,
      setContactOwner,
      contactOwnerId,
      selectedContactOwner,
      contactOwners,
      dateLoading,
      nameLoading,
      sortName,
      sortDate,
      sortByName,
      sortByDate,
      currentUser,
      allcountries,
      tenantCountry,
      whatsappmessage,
      marked,
      handleFilter,
      handleSearchTextUpdate,
      searchValue,
      whatsappClientState,
      clientSessionId,
      showWhatsapp,
      displayWhatsappDrawer,
      sendWhatsapp,
      whatsappRecipient,
      sendWhatsappToMultiple,
      churchMembers,
      navigatorLang,
      showFilter,
      allGroupLoading,
      singleGroupLoading,
      archiveLoading,
      addToGroupDialog,
      chooseGrouptoMoveAllMembers,
      handleSelectionChange,
      displayPositionArchive,
      handleCurrentChange,
      handleSizeChange,
      filterFormIsVissible,
      toggleFilterFormVissibility,
      moment,
      formatDate,
      applyFilter,
      filter,
      getAllGroups,
      toggleSearch,
      searchIsVisible,
      filterResult,
      searchText,
      showConfirmModal,
      deleteMember,
      membersCount,
      getPeopleByPage,
      clearInput,
      checkedFirstTimer,
      check1item,
      markAllFirsttimer,
      deleteFirstTimer,
      modal,
      deleteMessage,
      display,
      sendMarkedMemberSms,
      sendMarkedMemberEmail,
      membershipCategory,
      chooseCategory,
      totalFirsttimersCount,
      searchMemberInDB,
      searchNamesInDB,
      listOfFirsttimers,
      searchMember,
      clearAll,
      contacts,
      // disableBtn,
      hide,
      totalItems,
      setFirsttimer,
      firstTimerLink,
      markedFirsttimers,
      tenantID,
      selectedLink,
      showSMS,
      showEmail,
      copylink,
      setTotalFirstTimer,
      totalFirstTimer,
      getUser,
      serverOptions,
      paginatedTableLoading,
      firstTimerHeaders,
      selectedImage,
      imageDialog,
      showMemberRow,
      xsOnly,
      mdAndUp,
      lgAndUp,
      xlAndUp,
      applyLoading,
      searchingMember,
      primarycolor,
      showConfirmModal1,
      addToGroupSingle,
      deleteMarked,
      archive,
      moveMemberToGroup,
      openPositionArchive,
      getAllMembersAndAddToGroup,
      chooseGroupforAllmembers,
      chooseGrouptoMoveto,
      chooseGroupto,
      lifeCycle,
      selectedLifeCycle,
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.text-color:hover {
  color: #007bff;
}

.fade-text {
  color: #a8a8a8;
  cursor: not-allowed;
}

.text-color {
  color: #212529;
}

.my-con {
  justify-content: space-between;
  margin: 24px 0;
}

.chart-con {
  width: 70%;
  display: flex;
  justify-content: space-between;
}

.total {
  margin-bottom: 40px;
  font-size: 37px;
}

.total-text {
  font-size: 15px;
  font-weight: 700;
}

.filter-options {
  height: 0;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.filter-options-shown {
  height: 80px !important;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  background: #ffffff;
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}

a {
  text-decoration: none;
}

.clear-link,
.hide-link {
  color: #136acd;
}

.table-top {
  position: absolute;
  /* z-index: 1; */
  top: -40px;
  /* width: 100%; */
  font-weight: 500 !important;
  font-size: 14px;
  background: #fff;
  color: #000000;
  /* border: 1px solid #d4dde3; */
  /* max-width: 83.333333% !important; */
}
.tab-options {
  position: relative;
}

.m-wrapper {
  background-color: white !important;
  width: 875px;
  position: absolute;
  right: 0px;
  top: 0;
  height: 100%;
  padding: 70px;
  transition: all 3s ease-out;
}

.m-wrapper2 {
  background-color: white !important;
  width: 875px;
  position: absolute;
  right: 0px;
  top: 0;
  /* height: 100%; */
  padding: 70px;
}

.no-show {
  width: -875px;
  transition: all 3s ease-out;
  /* transition: all  8s cubic-bezier(0.645, 0.045, 0.355, 1); */
}

@media screen and (max-width: 947px) {
  .m-wrapper,
  .m-wrapper2 {
    width: 700px;
    padding: 50px;
  }
}

@media screen and (max-width: 767px) {
  .m-wrapper,
  .m-wrapper2 {
    width: 400px;
    padding: 40px;
  }

  .filter-options-shown {
    height: 150px;
  }

  .push-down {
    margin-top: 10px;
  }
}

@media screen and (max-width: 575px) {
  .m-wrapper,
  .m-wrapper2 {
    width: 350px;
    padding: 20px;
  }
}

@media (max-width: 414px) {
  .head-button {
    flex-direction: column;
    align-items: center;
  }

  .botom {
    border-bottom: 7px solid rgb(252, 248, 248);
    border-radius: 2px;
    position: relative;
    display: flex;
  }

  .more {
    margin-right: 0;
  }

  .baseline {
    position: relative;
    border-radius: 10px;
    z-index: 175;
    top: -4px;
    left: 0px;
    /* width: 35%; */
    opacity: 1;
  }
}

@media (max-width: 575px) {
  .head-button {
    display: flex;
    justify-content: center;
  }

  .add-btn,
  .more {
    margin-top: 10px;
  }

  .first-timers-text {
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .filter-options-shown {
    height: 150px !important;
    overflow: hidden;
    transition: all 0.5s ease-in-out;
  }
}

@media screen and (max-width: 1024px) {
  .my-con {
    flex-direction: column;
  }
}

@media (min-width: 767px) {
  .push-down {
    margin-top: 106px;
  }
}
</style>
